export const FINISHED = 'finished';
export const REPORTED = 'reported';
export const STARTED = 'started';
export const DONE = 'done';
export const ONGOING = 'ongoing';
export const ACTIVE = 'active';
export const OPEN = 'open';
export const CLOSED = 'closed';
